import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2';
import Hero5 from '../../components/hero5';
import SzallasokSection from '../../components/SzallasokSection';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../images/zsofi_es_peti_eskuvoje_logo_white.png';
import Footer from '../../components/footer';

const SzallasokPage = () => {
    return (
        <Fragment>
            <Navbar2 Logo={Logo} topbarNone={'topbarNone'} hclass={'wpo-header-style-3'} />
            <Hero5 />
            <SzallasokSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default SzallasokPage;
